import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a89bd2f"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("p", {
        class: "guide-text",
        innerHTML: __props.content
      }, null, 8, _hoisted_1);
    };
  }
};